(function () {
  function initReviews(root) {
    if (!root || root.dataset.wigReviewsInit === 'true') return;
    root.dataset.wigReviewsInit = 'true';

    var perPage = parseInt(root.dataset.perPage, 10) || 5;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-review-item]'));
    var pagination = root.querySelector('[data-reviews-pagination]');
    var pageNumbers = root.querySelector('[data-page-numbers]');
    var prevBtn = root.querySelector('[data-page-prev]');
    var nextBtn = root.querySelector('[data-page-next]');
    var page = 1;

    if (!items.length) return;

    function render() {
      var totalPages = Math.max(1, Math.ceil(items.length / perPage));
      if (page > totalPages) page = totalPages;

      var start = (page - 1) * perPage;
      items.forEach(function (item, index) {
        item.hidden = index < start || index >= start + perPage;
      });

      if (!pagination || !pageNumbers) return;

      if (items.length <= perPage) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;
      pageNumbers.innerHTML = '';

      for (var i = 1; i <= totalPages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wig-pdp-reviews__page-num' + (i === page ? ' is-active' : '');
        btn.textContent = String(i);
        btn.dataset.page = String(i);
        btn.addEventListener('click', function () {
          page = parseInt(this.dataset.page, 10);
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        pageNumbers.appendChild(btn);
      }

      if (prevBtn) prevBtn.disabled = page <= 1;
      if (nextBtn) nextBtn.disabled = page >= totalPages;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (page > 1) {
          page -= 1;
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var totalPages = Math.max(1, Math.ceil(items.length / perPage));
        if (page < totalPages) {
          page += 1;
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-wig-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wig-reviews]');
    if (root) initReviews(root);
  });
})();
